import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * `size` is a convenience shorthand for the icon's pixel size. It is applied
 * through `sx` rather than the `fontSize` prop: `SvgIcon` builds a utility class
 * by running `capitalize(fontSize)`, which throws on a number.
 */
type MdiIconProps = SvgIconProps & {
    d?: string;
    path?: string;
    size?: number | string;
};

function MdiIcon({ d, path, size, sx, ...rest }: MdiIconProps) {
    const iconPath = d || path;
    return (
        <SvgIcon {...rest} sx={size !== undefined ? { fontSize: size, ...sx } : sx}>
            {iconPath && <path d={iconPath} />}
        </SvgIcon>
    );
}

export default MdiIcon;